<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;" v-if="mode !== 'detail'">
        お知らせ - 編集
        <div class="headerBtn" @click="screenTransition(notifiationslistPath)" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg || postLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 登録エラー表示 -->
      <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの更新中に問題が発生しました。
          </div>
        </div>
      </div>
      <!-- 入力フォーム -->
      <form v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="inputTitle" style="display: flex;">
            カテゴリー
          </div>
          <div class="row">
            <validation-provider name="カテゴリー" rules="required" v-if="mode !== 'detail'" mode="lazy">
              <div slot-scope="ProviderProps">
                <div class="selectdiv">
                  <select  v-model="detail.notificationCategory" @change='changeCategory'>
                    <option value="" selected>カテゴリーを選択</option>
                    <option v-for="categories in optioncategories"
                    v-bind:value="categories.id">
                    {{ categories.name }}
                  </option>
                </select>
              </div>
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
          <div v-if="mode === 'detail'">
            <input class="text large" v-model="detail.notificationCategory" style="width: 500px;" readonly>
          </div>
        </div>
        <div class="inputTitle" style="display: flex;">
          タイトル
        </div>
        <div class="row">
          <validation-provider name="タイトル" rules="required|max:255" mode="lazy">
            <div slot-scope="ProviderProps">
              <input class="text large" v-model="detail.notificationTitle"
              style="width: 500px;" :readonly="mode == 'detail'"
              :placeholder="notificationDetail.title">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
        </div>
        <div v-if="mode == 'edit'" class="inputTitle" style="display: flex;">
          本文（HTML不可）
        </div>
        <div v-if="mode == 'detail'" class="inputTitle" style="display: flex;">
          本文
        </div>
        <div class="row">
          <validation-provider name="本文" rules="required|max:65535" mode="lazy">
            <div slot-scope="ProviderProps">
              <textarea class="text large"
              rows="10" cols="60" v-model="detail.notificationBody"
              style="height: 200px; width: 500px; max-height: 200; overflow-y: auto;"
              :readonly="mode == 'detail'"
              :placeholder="notificationDetail.body">
              </textarea>
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
        </div>
        <div class="inputTitle" style="display: flex;">
          有効期限
        </div>
        <div class="row">
          <validation-provider name="有効期限" rules="required" mode="lazy">
            <div slot-scope="ProviderProps">
              <input type="date" max="9999-12-31" class="text large"
              v-model="detail.notificationExpiredAt"
              :readonly="mode == 'detail'">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
        </div>

        <div class="buttonGroup" v-if="mode !== 'detail'">
          <button @click="confirm" class="btn" type = "button"
          :class="{
            disabled: ObserverProps.invalid || !ObserverProps.validate,
            active: !ObserverProps.invalid && ObserverProps.validate
           }"
          :disabled="ObserverProps.invalid">変更
        </button>
      </div>
    </validation-observer>
  </form>
</div>
</div>

</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import moment from 'moment';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';

export default {
  title: 'お知らせ編集',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  props: {
    mode: {
      type: String,
      default: 'edit',
      required: true,
    },
    id: {
      type: String,
      default: '0',
      required: true,
    },
  },
  data() {
    return {
      notifiationslistPath: '/notifications', // お知らせ一覧パス
      // 入力項目モデル
      detail: {
        notificationCategory: '',
        notificationTitle: '',
        notificationBody: '',
        notificationExpiredAt: '',
      },
      // 登録済みデータ取得
      notificationDetail: {},
      // ドロップダウンリスト
      selectedcategories: '', // 選択お知らせカテゴリ
      optioncategories: [], // お知らせカテゴリ配列
      // ローディング
      getLodingFlg: true, // データ取得時ローディング用フラグ
      getErrorFlg: false, // データ取得時エラーフラグ
      postLodingFlg: false, // データ更新時ローディングフラグ
      postErrorFlg: false, // データ更新時エラーフラグ
      errorMessage: '',
    };
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  async mounted() {
    try {
      // お知らせカテゴリ取得API呼出
      this.optioncategories = await this.callGetNotificationCategories();
      // お知らせ一意情報取得API呼出
      this.notificationDetail = await this.callGetNotification();
      // 表示情報の詰めなおし
      this.detail.notificationCategory = this.notificationDetail.notificationCategoryId;
      this.detail.notificationTitle = this.notificationDetail.title;
      this.detail.notificationBody = this.notificationDetail.body;
      this.detail.notificationExpiredAt = common.dateFormatHyphen(this.notificationDetail.expiredAt);
      this.selectedcategories = this.notificationDetail.notificationCategoryId;
      // 詳細画面の場合、カテゴリIDでなくカテゴリ名を表示する必要がある
      // APIのレスポンスにカテゴリ名が加わり次第不要となる
      if (this.mode === 'detail') {
        this.detail.notificationCategory =
        this.categoryConversion(this.detail.notificationCategory, this.optioncategories);
      }
      // await new Promise((resolve) => setTimeout(resolve, 300));
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      this.getLodingFlg = false;
    }
  },
  methods: {
    // お知らせカテゴリ取得API呼び出し
    async callGetNotificationCategories() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getNotificationCategories();
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // お知らせ一意情報取得API呼び出し
    async callGetNotification() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getNotification(this.id);
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // カテゴリIDからカテゴリ名を返却
    categoryConversion(value, list) {
      const result = list.find((v) => v.id === value);
      if (result) {
        return result.name;
      }
    },
    // 変更ボタン押下時処理
    async confirm() {
      try {
        this.postLodingFlg = true;
        this.postErrorFlg = false;
        // カレンダーの値をUnixtimeへ変換
        const notificationExpiredAt = new Date(this.detail.notificationExpiredAt).getTime();
        // お知らせ更新API呼び出し
        const body = {
          id: this.id,
          notificationCategoryId: this.selectedcategories,
          title: this.detail.notificationTitle,
          body: this.detail.notificationBody,
          expiredAt: notificationExpiredAt,
        };
        const restResourceService = new ApiClient();
        await restResourceService.putNotification(body);
        // お知らせ一覧画面に戻る
        this.screenTransition(this.notifiationslistPath);
      } catch (error) {
      this.errorMessage = error.message;
      this.postErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
      }
    },
    // プルダウン選択内容取得・更新
    changeCategory(value) {
      this.selectedcategories = value.target.value;
    },
    // 画面遷移
    screenTransition(path) {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/variables.scss";

</style>
